// backendService.js
import { BACKEND_CONFIG } from '../config.js';

const API_URL = BACKEND_CONFIG.API_URL;

/**
 * Process a PDF file using the backend API
 * @param {File} file - The PDF file to process
 * @returns {Promise<Array>} - Array of extracted grocery items
 */
export async function processPdfWithBackend(file) {
  try {
    // Create form data with the file
    const formData = new FormData();
    formData.append('pdfFile', file);
    
    // Send the file to the backend
    const response = await fetch(`${API_URL}/azure/process-pdf`, {
      method: 'POST',
      body: formData,
    });
    
    // Parse the response
    const data = await response.json();
    
    if (!data.success) {
      throw new Error(data.message || 'Failed to process PDF');
    }
    
    // Return the extracted items
    return data.items;
  } catch (error) {
    console.error('Error processing PDF with backend:', error);
    throw error;
  }
}

/**
 * Test the connection to the backend
 * @returns {Promise<Object>} - Connection test result
 */
export async function testBackendConnection() {
  try {
    const response = await fetch(`${API_URL}/test`);
    return await response.json();
  } catch (error) {
    console.error('Error testing backend connection:', error);
    throw error;
  }
}

/**
 * Test the connection to Azure services
 * @returns {Promise<Object>} - Azure connection test result
 */
export async function testAzureConnection() {
  try {
    const response = await fetch(`${API_URL}/azure/test-connection`);
    return await response.json();
  } catch (error) {
    console.error('Error testing Azure connection:', error);
    throw error;
  }
}
